import {CSSProperties, FC, HTMLAttributes} from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import clsx from 'clsx';

type SortableItemProps = {
    disabled?: boolean;
    id: string;
} & HTMLAttributes<HTMLDivElement>;

const SortableItem: FC<SortableItemProps> = ({
    children,
    className,
    disabled,
    id,
    ...divProps
}) => {
    const {active, attributes, isSorting, setNodeRef, transform, transition} =
        useSortable({
            disabled,
            id,
        });

    const selected = active !== null && id === active.id;

    const style: CSSProperties = {
        transform: CSS.Translate.toString(transform),
        transition,
    };

    return (
        <div
            ref={setNodeRef}
            className={clsx(
                'cursor-auto',
                selected && 'opacity-50',
                isSorting && 'pointer-events-none',
                className,
            )}
            style={style}
            {...attributes}
            {...divProps}
        >
            {children}
        </div>
    );
};

export default SortableItem;
